export default __webpack_public_path__ + "static/media/ic_tiktok.b71a2bd6.png";